(function () {
  'use strict';

  var GA4_MEASUREMENT_ID = 'G-PKHVJ3LX7Z';
  var TRACKING_VERSION = 'mma_blog_attribution_20260724_v2';
  var ROOT_SELECTOR = '[data-mma-blog-attribution]';
  var ARTICLE_LINK_SELECTOR = '.article-content a[href], .blog-article-nav a[href], .article-tags a[href]';
  var INDEX_LINK_SELECTOR = 'a[href]';
  var trackedViews = new Set();
  var deliveredEvents = new Set();
  var pendingViews = new Map();

  function compact(input) {
    var output = {};
    Object.keys(input || {}).forEach(function (key) {
      var value = input[key];
      if (value !== undefined && value !== null && value !== '') output[key] = value;
    });
    return output;
  }

  function normalizeText(value, limit) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, limit || 100);
  }

  function analyticsStatus() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed();
      }
    } catch (error) {
      return false;
    }
    return null;
  }

  function analyticsAllowed() {
    return analyticsStatus() === true;
  }

  function getCookie(name) {
    var prefix = name + '=';
    var item = document.cookie.split('; ').find(function (cookie) {
      return cookie.indexOf(prefix) === 0;
    });
    return item ? decodeURIComponent(item.slice(prefix.length)) : '';
  }

  function gaClientId() {
    var gaCookie = getCookie('_ga');
    var parts = gaCookie.split('.');
    if (parts.length >= 4) return parts.slice(-2).join('.');

    var storageKey = 'mma_blog_ga_cid';
    try {
      var stored = window.sessionStorage.getItem(storageKey);
      if (stored) return stored;
      var generated = Math.floor(Math.random() * 2147483647) + '.' + Math.floor(Date.now() / 1000);
      window.sessionStorage.setItem(storageKey, generated);
      return generated;
    } catch (error) {
      return Math.floor(Math.random() * 2147483647) + '.' + Math.floor(Date.now() / 1000);
    }
  }

  function gaSessionId() {
    var cookieName = '_ga_' + GA4_MEASUREMENT_ID.replace('G-', '');
    var value = getCookie(cookieName);
    var gs2 = value.match(/(?:^|\$)s(\d+)(?:\$|$)/);
    if (gs2) return gs2[1];

    var gs1 = value.match(/^GS\d+\.\d+\.(\d+)(?:\.|$)/);
    if (gs1) return gs1[1];

    var storageKey = 'mma_blog_ga_sid';
    try {
      var stored = window.sessionStorage.getItem(storageKey);
      if (stored) return stored;
      var generated = String(Math.floor(Date.now() / 1000));
      window.sessionStorage.setItem(storageKey, generated);
      return generated;
    } catch (error) {
      return String(Math.floor(Date.now() / 1000));
    }
  }

  function sendGa4Direct(name, payload) {
    var query = new URLSearchParams({
      v: '2',
      tid: GA4_MEASUREMENT_ID,
      cid: gaClientId(),
      en: name,
      _p: String(Date.now()),
      dl: window.location.href,
      dt: document.title,
      sr: window.screen.width + 'x' + window.screen.height,
      ul: (navigator.language || 'en-us').toLowerCase(),
      sid: gaSessionId(),
      sct: '1',
      seg: '1'
    });

    Object.keys(payload).forEach(function (key) {
      var value = payload[key];
      var prefix = typeof value === 'number' ? 'epn' : 'ep';
      query.set(prefix + '.' + key, String(value));
    });

    var endpoint = 'https://region1.analytics.google.com/g/collect?' + query.toString();
    var sent = false;
    try {
      sent = typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(endpoint, '');
    } catch (error) {
      sent = false;
    }

    if (!sent && typeof window.fetch === 'function') {
      window.fetch(endpoint, { method: 'POST', mode: 'no-cors', keepalive: true }).catch(function () {});
    }
  }

  function sendGa4(name, payload) {
    if (!analyticsAllowed()) return;

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, Object.assign({ send_to: GA4_MEASUREMENT_ID }, payload));
        return;
      }
    } catch (error) {
      // Use the consent-aware direct transport below.
    }

    sendGa4Direct(name, payload);
  }

  function sendTripleWhale(name, payload) {
    if (!analyticsAllowed()) return false;
    try {
      if (typeof window.TriplePixel === 'function') {
        window.TriplePixel('custom', name, payload);
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  }

  function publishShopify(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (error) {
      // GA4 and Triple Whale remain the reporting destinations.
    }
  }

  function eventKey(name, payload) {
    return [
      name,
      payload.blog_article_id || payload.blog_article || payload.blog_category || window.location.pathname,
      payload.blog_link_position || '',
      payload.blog_target_path || ''
    ].join('|');
  }

  function deliver(name, payload) {
    var key = eventKey(name, payload);
    if (/_view$/.test(name)) {
      if (deliveredEvents.has(key)) return;
      deliveredEvents.add(key);
    }

    sendGa4(name, payload);
    if (!sendTripleWhale(name, payload)) {
      window.setTimeout(function () {
        sendTripleWhale(name, payload);
      }, 1500);
    }
    publishShopify(name, payload);
    document.dispatchEvent(new CustomEvent('mma:blog-attribution', {
      detail: Object.assign({ event: name }, payload)
    }));
  }

  function publish(name, payload, consentAttempt) {
    var status = analyticsStatus();
    var attempt = consentAttempt || 0;
    if (status === null && attempt < 12) {
      window.setTimeout(function () {
        publish(name, payload, attempt + 1);
      }, 250);
      return;
    }
    var cleanPayload = compact(payload);
    if (status !== true) {
      if (/_view$/.test(name)) pendingViews.set(eventKey(name, cleanPayload), { name: name, payload: cleanPayload });
      return;
    }

    deliver(name, cleanPayload);
  }

  function flushPendingViews() {
    if (!analyticsAllowed()) return;
    pendingViews.forEach(function (pending) {
      deliver(pending.name, pending.payload);
    });
    pendingViews.clear();
  }

  function recordDebug(root, name, payload) {
    var query = new URLSearchParams(window.location.search);
    if (
      query.get('_qa') !== 'blog-attribution-v1' &&
      query.get('_qa') !== 'category-attribution-v1' &&
      query.get('mma_blog_debug') !== '1'
    ) return;
    root.setAttribute('data-mma-blog-last-event', JSON.stringify(Object.assign({
      event: name,
      analytics_allowed: analyticsStatus(),
      ga_transport: typeof window.gtag === 'function' ? 'gtag' : 'direct',
      triple_whale_available: typeof window.TriplePixel === 'function'
    }, payload)));
  }

  function rootPayload(root) {
    return {
      blog_article: normalizeText(root.dataset.mmaBlogArticle, 100),
      blog_category: normalizeText(root.dataset.mmaBlogCategory, 100),
      blog_article_id: normalizeText(root.dataset.mmaBlogArticleId, 100),
      blog_page_type: normalizeText(root.dataset.mmaBlogPageType || 'article', 40),
      blog_page_path: window.location.pathname,
      tracking_version: TRACKING_VERSION
    };
  }

  function targetData(link) {
    var rawHref = link.getAttribute('href') || '';
    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (error) {
      return null;
    }

    if (!/^https?:$/.test(url.protocol)) return null;
    if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.hash) return null;

    var sameOrigin = url.origin === window.location.origin;
    var parts = url.pathname.split('/').filter(Boolean);
    var type = sameOrigin ? 'internal_other' : 'external';
    var handle = sameOrigin ? (parts[0] || 'home') : url.hostname.replace(/^www\./, '');

    if (sameOrigin && parts[0] === 'products' && parts[1]) {
      type = 'product';
      handle = parts[1];
    } else if (sameOrigin && parts[0] === 'collections' && parts[1]) {
      type = 'collection';
      handle = parts[1];
    } else if (sameOrigin && parts[0] === 'blogs' && parts[1] && parts[2]) {
      type = 'article';
      handle = parts[1] + '/' + parts[2];
    } else if (sameOrigin && parts[0] === 'blogs' && parts[1]) {
      type = 'blog_index';
      handle = parts[1];
    } else if (sameOrigin && parts[0] === 'pages' && parts[1]) {
      type = 'page';
      handle = parts[1];
    }

    return {
      blog_target_type: type,
      blog_target_handle: normalizeText(handle, 100),
      blog_target_path: normalizeText(sameOrigin ? url.pathname : url.origin + url.pathname, 100),
      outbound: sameOrigin ? 0 : 1
    };
  }

  function linkPlacement(link) {
    var declaredPlacement = link.closest('[data-mma-blog-placement]');
    if (declaredPlacement && declaredPlacement.dataset.mmaBlogPlacement) {
      return normalizeText(declaredPlacement.dataset.mmaBlogPlacement, 60);
    }
    if (link.closest('.mw-product-card')) return 'product_card';
    if (link.closest('table')) return 'comparison_table';
    if (link.closest('.blog-article-nav')) return 'article_nav';
    if (link.closest('.article-tags')) return 'article_tags';
    return 'article_body';
  }

  function sectionHeading(root, link) {
    if ((root.dataset.mmaBlogPageType || 'article') === 'index') return linkPlacement(link);
    var content = link.closest('.article-content');
    if (!content) return linkPlacement(link);

    var heading = 'introduction';
    Array.from(content.querySelectorAll('h2, h3')).some(function (candidate) {
      var relation = candidate.compareDocumentPosition(link);
      if (relation & Node.DOCUMENT_POSITION_FOLLOWING) {
        heading = normalizeText(candidate.textContent, 100) || heading;
        return false;
      }
      return true;
    });
    return heading;
  }

  function trackView(root) {
    var pageType = root.dataset.mmaBlogPageType || 'article';
    var eventName = pageType === 'index' ? 'mma_blog_index_view' : 'mma_blog_view';
    var selector = pageType === 'index' ? INDEX_LINK_SELECTOR : ARTICLE_LINK_SELECTOR;
    var key = eventName + '|' + (root.dataset.mmaBlogArticleId || window.location.pathname);
    if (trackedViews.has(key)) return;
    trackedViews.add(key);

    var payload = Object.assign(rootPayload(root), {
      blog_link_count: root.querySelectorAll(selector).length
    });
    publish(eventName, payload);
    recordDebug(root, eventName, payload);
  }

  function trackClick(root, link, event) {
    var pageType = root.dataset.mmaBlogPageType || 'article';
    var eventName = pageType === 'index' ? 'mma_blog_index_link_click' : 'mma_blog_link_click';
    var selector = pageType === 'index' ? INDEX_LINK_SELECTOR : ARTICLE_LINK_SELECTOR;
    var target = targetData(link);
    if (!target) return;
    var qaMode = new URLSearchParams(window.location.search).get('_qa');
    if (qaMode === 'blog-attribution-v1' || qaMode === 'category-attribution-v1') {
      event.preventDefault();
    }

    var links = Array.from(root.querySelectorAll(selector));
    var position = links.indexOf(link) + 1;
    var payload = Object.assign(rootPayload(root), target, {
      blog_link_text: normalizeText(link.textContent || link.getAttribute('aria-label') || '', 100),
      blog_link_section: sectionHeading(root, link),
      blog_link_placement: linkPlacement(link),
      blog_link_position: position > 0 ? position : undefined,
      interaction_method: event.detail === 0 ? 'keyboard' : 'pointer'
    });

    publish(eventName, payload);
    recordDebug(root, eventName, payload);
  }

  function init(root) {
    if (root.dataset.mmaBlogAttributionInitialized === 'true') return;
    root.dataset.mmaBlogAttributionInitialized = 'true';
    trackView(root);

    root.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      var selector = (root.dataset.mmaBlogPageType || 'article') === 'index' ? INDEX_LINK_SELECTOR : ARTICLE_LINK_SELECTOR;
      if (!link || !root.contains(link) || !link.matches(selector)) return;
      trackClick(root, link, event);
    }, true);
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('visitorConsentCollected', flushPendingViews);
})();
